/**
 * Copyright 2016 xdot GmbH
 *
 * Author: Carsten Hibbeler
 * Date: 23.06.2016
 *
 */

import React, { useEffect, useState } from 'external/react';
import PropTypes from 'external/prop-types';
import { Tab, Tabs } from 'external/react-bootstrap';
import { Header } from 'plugin/liferay-widgets-react-web';
import '../css/treelist.scss';
import '../css/layer-chooser.scss';
import { LayerLegend } from './LayerLegend';
import { isLayerSet } from '../utils/map-config-util';
import { ObjectInfoPreview } from '../plugins/ExternalLayerFeatureClickPlugin/ObjectInfoPreview';

function getActiveLayerConfigs(layerConfigs, activeUuids){
    if (!layerConfigs || !activeUuids) {
        return [];
    }
    return layerConfigs.reduce((acc, item) => {
        const isLayersSet = isLayerSet(item);
        if (isLayersSet) {
            acc = [...acc, ...getActiveLayerConfigs(item.children, activeUuids)];
        } else if (!isLayersSet && activeUuids[item.uuid]) {
            const typeKey = item.children && item.children[0] && item.children[0].typeKey;
            acc.push({ ...item, typeKey });
        }
        return acc;
    }, []);
}

function parseConfig(c){
    try {
        return JSON.parse(c);
    } catch (e) {
        console.warn(e);
        return undefined;
    }
}

function getActiveLegends(layerConfigs, activeUuids){
    if (!layerConfigs || !activeUuids) {
        return [];
    }
    return layerConfigs.reduce((acc, item) => {
        const isLayersSet = isLayerSet(item);
        if (isLayersSet) {
            const activeLayerSetLayers = getActiveLayerConfigs(item.children, activeUuids);
            if (activeLayerSetLayers.length > 0 && item.config) {
                const configJson = parseConfig(item.config);
                if (configJson && configJson.legend && activeLayerSetLayers.length > 0) {
                    acc.push({
                        title: item.title,
                        legend: configJson.legend,
                        legendClass: configJson.legendClass || '',
                        legendTitleSuffix: configJson.legendTitleSuffix || ''
                    });
                } else {
                    acc = [...acc, ...getActiveLegends(item.children, activeUuids)];
                }
            } else {
                acc = [...acc, ...getActiveLegends(item.children, activeUuids)];
            }
        } else if (!isLayersSet && activeUuids[item.uuid]) {
            const configString = item.children && item.children[0] && item.children[0].config;
            const configJson = parseConfig(configString);
            if (configJson && configJson.legend) {
                acc.push({
                    title: item.title,
                    legend: configJson.legend,
                    legendClass: configJson.legendClass || '',
                    legendTitleSuffix: configJson.legendTitleSuffix || ''
                });
            }
        }
        return acc;
    }, []);
}

const LayerInfoSidebar = ({ layerDescriptions, onClose, activeLayerUuids, layers, latlng, metresPerPixel }) => {
    const [activeTab, setActiveTab] = useState('object-info');
    const activeLayerConfigs = layerDescriptions && getActiveLayerConfigs(layerDescriptions, activeLayerUuids);
    const legends = layerDescriptions && getActiveLegends(layerDescriptions, activeLayerUuids);

    useEffect(() => {
        setActiveTab('object-info');
    }, [latlng]);

    return (
        <div className="layer-chooser">
            <Header onClose={onClose}>
                <h3 className="m-0 leaflet-sidebar__title">Objektinfo & Legende</h3>
            </Header>

            <div className="layer-chooser__content">
                <Tabs
                    activeKey={activeTab}
                    onSelect={setActiveTab}
                >
                    <Tab eventKey="object-info" title="Objektinfo">
                        <div className="py-2">
                            <ObjectInfoPreview
                                layerConfigs={activeLayerConfigs}
                                layers={layers}
                                latlng={latlng}
                                metresPerPixel={metresPerPixel}
                            />
                        </div>
                    </Tab>
                    <Tab eventKey="legend" title="Legende">
                        <div className="py-2">
                            <LayerLegend
                                legends={legends}
                                onClose={onClose}
                            />
                        </div>
                    </Tab>
                </Tabs>
            </div>

        </div>
    );
};

LayerInfoSidebar.propTypes = {
    layerDescriptions: PropTypes.array,
    activeLayerUuids: PropTypes.object,
    onClose: PropTypes.func,
    layers: PropTypes.object,
    latlng: PropTypes.object,
    metresPerPixel: PropTypes.number,
};

export default LayerInfoSidebar;



// WEBPACK FOOTER //
// ./js/components/LayerInfoSidebar.jsx